import React from 'react';

const ErrorGraphic = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    viewBox="0 0 519 1121"
    xmlSpace="preserve"
    className="image-404"
  >
    <g id="Page-1">
      <radialGradient
        id="radial-grad-1"
        cx="50%"
        y="50%"
      >
        <stop offset="0%" stopColor="#9b3c8e" className="stop-1" />
        <stop offset="100%" stopColor="#1f3460" className="stop-2" />
      </radialGradient>

      <path
        id="polygon-1"
        fill="url(#radial-grad-1)"
        stroke="#1F3460"
        strokeWidth="1.0971"
        d="M160.3,16.9L284.5,90v143.9l-124.2,70.4L36,233.9V90L160.3,16.9z"
      />
      <path
        id="polygon-2"
        fill="url(#radial-grad-1)"
        stroke="#9B3C8E"
        strokeWidth="1.0971"
        d="M69.8,321.8l31.1,18.2v35.9l-31.1,17.6l-31.1-17.6V340L69.8,321.8z"
      />
      <path
        id="polygon-3"
        fill="url(#radial-grad-1)"
        stroke="#9B3C8E"
        strokeWidth="1.0971"
        d="M383.4,39.2l24.5,14.3v28.2l-24.5,13.8l-24.5-13.8V53.5L383.4,39.2z"
      />
      <path
        id="polygon-4"
        fill="url(#radial-grad-1)"
        stroke="#9B3C8E"
        strokeWidth="0.8363"
        d="M409.7,177l50.9,29.9v59l-50.9,28.9l-50.9-28.9v-59L409.7,177z"
      />
      <path
        id="polygon-5"
        fill="url(#radial-grad-1)"
        stroke="#1F3460"
        strokeWidth="0.8881"
        d="M244.4,358.9l41.1,24.2v47.7l-41.1,23.3l-41.1-23.3v-47.7L244.4,358.9z"
      />
      <path
        id="polygon-6"
        fill="url(#radial-grad-1)"
        stroke="#9B3C8E"
        strokeWidth="0.7613"
        d="M114.3,477.3l50.7,29.8v58.8l-50.7,28.8l-50.7-28.8v-58.8L114.3,477.3z"
      />
      <path
        id="polygon-8"
        fill="url(#radial-grad-1)"
        stroke="#9B3C8E"
        strokeWidth="1.0971"
        d="M422.4,393.5l29.4,17.2v33.9l-29.4,16.7L393,444.7v-33.9L422.4,393.5z"
      />
      <path
        id="polygon-9"
        fill="url(#radial-grad-1)"
        stroke="#9B3C8E"
        strokeWidth="1.1136"
        d="M358.9,483l67.7,39.9v78.5l-67.7,38.4l-67.7-38.4v-78.5L358.9,483z"
      />
    </g>
  </svg>
);
export default ErrorGraphic;
